import Vue from "vue";
import VueRouter from "vue-router";

import NProgress from 'nprogress'

import Home from "../views/Home.vue";
import Login from '../views/Login.vue';
import Welcome from '../views/Welcome.vue';

Vue.use(VueRouter);

const childrenHome = [
  {
    path: '/',
    name: 'Welcome',
    component: Welcome,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/miscuentas',
    name: 'MisCuentas',
    component: () => import('../views/MisCuentas.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/mistarjetas',
    name: 'MisTarjetas',
    component: () => import('../views/MisTarjetas.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/transferencias',
    name: 'Transferencias',
    component: () => import('../views/Transferencias.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/sipap',
    name: 'Sipap',
    component: () => import('../views/Sipap.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/inter',
    name: 'Inter',
    component: () => import('../views/Inter.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pagarservicios',
    name: 'PagarServicios',
    component: () => import('../views/PagarServicios.vue'),
    meta: {
      requiresAuth: true
    }
  },
]

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: childrenHome
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new VueRouter({
  //mode: "history",
  //base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  // check to see if route has auth guard
  if (to.matched.some(rec => rec.meta.requiresAuth)) {
    //console.log('Tiene meta');
    if (!window.localStorage.getItem('usuario')) {
      next({
        name: 'Login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
